(() => {
  if (window.QuadroEUProduct) return;
  const products = new Map();
  const panelSets = new WeakMap();
  let modelRuntime;
  const all = (root, selector) => Array.from(root.querySelectorAll(selector));
  const text = (root, selector, value) => all(root, selector).forEach(node => { node.textContent = value == null ? '' : String(value); });
  const hide = (node, hidden) => { if (node) { node.hidden = hidden; node.classList.toggle('hidden', hidden); } };
  function sourcePanels(root) {
    if (root.dataset.enableHistoryState !== 'true' && !root.hasAttribute('data-panel-set-main-product')) return [];
    return all(document, '.product-kits-source, .product-source').flatMap(source => all(source, '.quadro-kit-tabs').map(tabs => {
      const tab = Array.from(tabs.children).filter(item => item.classList.contains('quadro-kit-tab'))[1];
      return tab && all(source, '.quadro-kit-tab-content').find(panel => panel.id === tab.getAttribute('aria-controls'));
    }).filter(Boolean));
  }
  function updatePanelSetIncluded(root, variant) {
    const container = root.querySelector('[data-panel-set-templates]');
    if (!container) return false;
    let cached = panelSets.get(container);
    if (!cached) {
      const templates = all(container, 'template[data-panel-set-variant-id]');
      cached = {
        skus: new Map(templates.filter(node => /^[0-9]{5}$/.test(node.dataset.panelSetSku || '')).map(node => [node.dataset.panelSetSku, node])),
        variants: new Map(templates.map(node => [node.dataset.panelSetVariantId, node])),
        fallback: container.querySelector('template[data-panel-set-fallback]')
      };
      panelSets.set(container, cached);
    }
    const sku = String(variant?.sku || '').trim();
    const variantId = variant ? String(variant.id) : '';
    let template = variant ? (/^[0-9]{5}$/.test(sku) ? cached.skus.get(sku) : cached.variants.get(variantId)) : null;
    if (template && template.dataset.panelSetSku !== sku) template = null;
    const known = Boolean(template);
    template = template || cached.fallback;
    if (!template) return false;
    const lists = [...new Set([root.querySelector('[data-product-included-list]'), ...sourcePanels(root).map(panel => panel.querySelector('ul'))].filter(Boolean))];
    lists.forEach(list => {
      if (!known || list.dataset.panelSetCurrentSku !== sku || list.dataset.includedCurrentVariantId !== variantId) {
        list.replaceChildren(template.content.cloneNode(true));
      }
      list.dataset.panelSetCurrentSku = sku;
      list.dataset.includedCurrentVariantId = variantId;
      delete list.dataset.euBundleReady;
      if (!known) {
        text(list, '[data-variant-included-sku]', sku);
        all(list, '[data-variant-included-sku-wrap]').forEach(node => hide(node, !sku));
      }
    });
    return known;
  }
  function updateIncluded(root, variant) {
    updatePanelSetIncluded(root, variant);
  }
  function initProduct(root) {
    if (products.has(root)) return;
    const json = document.getElementById('EUProductJson-' + root.dataset.sectionId);
    const form = root.querySelector('form[data-product-form]'), master = root.querySelector('select[name="id"]');
    if (!json || !form || !master) return;
    let data; try { data = JSON.parse(json.textContent); } catch (_) { return; }
    const variants = data.variants || [], labels = data.labels || {}, media = all(root, '[data-product-single-media-wrapper]');
    const controller = new AbortController(), signal = controller.signal;
    products.set(root, controller);
    let selected, dispatching = false;
    function showMedia(id) {
      const target = media.find(node => node.dataset.mediaId === root.dataset.sectionId + '-' + id);
      if (!target) return;
      media.forEach(node => {
        const visible = node === target, wasVisible = !node.classList.contains('hide');
        node.classList.toggle('hide', !visible); node.setAttribute('aria-hidden', String(!visible));
        if (visible && window.QuadroEU) all(node, 'img').forEach(window.QuadroEU.loadImage);
        if (visible !== wasVisible) node.dispatchEvent(new CustomEvent(visible ? 'mediaVisible' : 'mediaHidden'));
      });
      all(root, '[data-thumbnail-id]').forEach(thumb => {
        const active = thumb.dataset.thumbnailId === target.dataset.mediaId;
        thumb.classList.toggle('active-thumb', active); thumb.setAttribute('aria-current', String(active));
      });
      const model = target.querySelector('model-viewer'), fallback = root.querySelector('model-viewer');
      all(root, '[data-shopify-xr]').forEach(button => button.dataset.shopifyModel3dId = (model || fallback)?.dataset.modelId || '');
    }
    function select(variant, updateUrl, notify) {
      selected = variant;
      const available = Boolean(variant && variant.available), button = form.querySelector('[data-add-to-cart]');
      if (button) { button.disabled = !available; if (available) button.removeAttribute('aria-disabled'); else button.setAttribute('aria-disabled', 'true'); button.classList.toggle('disable', !available); button.setAttribute('aria-label', variant ? (available ? labels.add : labels.soldOut) : labels.unavailable); }
      form.classList.toggle('product-form--variant-sold-out', !available);
      text(form, '[data-add-to-cart-text]', variant ? (available ? labels.add : labels.soldOut) : labels.unavailable);
      hide(root.querySelector('.extra-payment-methods'), !available);
      hide(form.querySelector('.shopify-payment-button'), !available);
      const price = root.querySelector('[data-price]');
      if (price) {
        price.classList.toggle('price--unavailable', !variant);
        price.classList.toggle('price--sold-out', Boolean(variant && !available));
        price.classList.toggle('price--on-sale', Boolean(variant && variant.onSale));
        price.classList.toggle('price--unit-available', Boolean(variant && variant.hasUnitPrice));
      }
      master.value = variant ? String(variant.id) : ''; master.disabled = !variant;
      if (!variant) { updatePanelSetIncluded(root, null); text(root, '[data-product-status]', labels.unavailable); return; }
      text(root, '.variant-sku, [data-variant-included-sku]', variant.sku);
      hide(root.querySelector('[data-variant-included-sku-wrap]'), !variant.sku);
      text(root, '.variant-barcode', variant.barcode); hide(root.querySelector('.variant-barcode-wrapper'), !variant.barcode);
      text(root, '[data-regular-price]', variant.onSale ? variant.comparePrice : variant.price);
      text(root, '[data-sale-price]', variant.price); text(root, '[data-unit-price]', variant.unitPrice); text(root, '[data-unit-price-base-unit]', variant.unitBase);
      Object.entries(variant.meta || {}).forEach(([key, value]) => {
        const item = root.querySelector('.meta-aqua .meta-' + key);
        if (item) { text(item, '.meta-value', typeof value === 'object' && value ? value.value : value); hide(item, !value); }
      });
      all(root, '[data-index]').forEach(input => {
        const index = Number((input.dataset.index || '').replace('option', '')) - 1;
        if (index < 0 || index > 2) return;
        if (input.type === 'radio') {
          input.checked = input.value === variant.options[index];
          const exists = variants.some(candidate => candidate.available && candidate.options[index] === input.value && candidate.options.every((value, i) => i === index || value === variant.options[i]));
          const label = input.labels && input.labels[0]; if (label) label.dataset.available = exists ? 'available' : 'unavailable';
        } else if (input.tagName === 'SELECT') input.value = variant.options[index];
      });
      all(root, '.variant-combo-input').forEach(input => { input.checked = input.dataset.variantId === String(variant.id); });
      showMedia(variant.mediaId); updateIncluded(root, variant, variants);
      if (updateUrl && root.dataset.enableHistoryState === 'true') { const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url); }
      if (notify) { dispatching = true; master.dispatchEvent(new Event('change', { bubbles: true })); dispatching = false; root.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant } })); }
      text(root, '[data-product-status]', variant.price + (available ? '' : ' ' + labels.soldOut));
    }
    root.addEventListener('change', event => {
      if (dispatching) return;
      const input = event.target;
      if (input === master) select(variants.find(item => String(item.id) === master.value), true, false);
      else if (input.matches('.variant-combo-input')) select(variants.find(item => String(item.id) === input.dataset.variantId), true, true);
      else if (input.matches('[data-index]')) {
        const options = [];
        all(root, 'select[data-index], input[data-index]:checked').forEach(control => { options[Number(control.dataset.index.replace('option', '')) - 1] = control.value; });
        select(variants.find(item => item.options.every((value, i) => value === options[i])), true, true);
      }
    }, { signal });
    root.addEventListener('click', event => {
      const thumb = event.target.closest('[data-thumbnail-id]');
      if (thumb && root.contains(thumb)) { event.preventDefault(); showMedia(thumb.dataset.thumbnailId.slice(root.dataset.sectionId.length + 1)); }
      const arrow = event.target.closest('.thumbnails-slider__btn');
      if (arrow) { const list = root.querySelector('.product-single__thumbnails'); if (list) list.scrollBy({ left: (arrow.classList.contains('thumbnails-slider__prev') ? -1 : 1) * list.clientWidth, behavior: 'smooth' }); }
    }, { signal });
    form.addEventListener('submit', event => {
      const quantity = form.querySelector('[name="quantity"]');
      if (!selected?.available || (quantity && !quantity.checkValidity())) { event.preventDefault(); event.stopImmediatePropagation(); if (quantity) quantity.reportValidity(); }
    }, { capture: true, signal });
    select(variants.find(item => String(item.id) === master.value) || variants[0], false, false);
    const model = root.querySelector('[data-quadro-model-runtime]');
    if (model) {
      if (!modelRuntime) modelRuntime = new Promise((resolve, reject) => {
        const script = document.createElement('script'); script.src = model.dataset.quadroModelRuntime;
        script.onload = resolve; script.onerror = () => { modelRuntime = null; reject(); }; document.head.append(script);
      });
      modelRuntime.then(() => { if (root.isConnected && products.has(root)) window.QuadroEUModels?.init(root); }).catch(() => {});
    }
  }
  // R9.11: the native default PDP uses theme.js for selection; listen to its native
  // select change instead of creating a second variant/cart controller.
  function initMinimalPanelSet(root) {
    if (products.has(root) || !root.querySelector('[data-product-included-list]')) return;
    const master = root.querySelector('[data-variant-select]');
    const json = root.querySelector('[data-product-variants]');
    if (!master || !json) return;
    let variants;
    try { variants = JSON.parse(json.textContent); } catch (_) { return; }
    if (!Array.isArray(variants)) return;
    const controller = new AbortController();
    products.set(root, controller);
    const update = () => {
      const variant = variants.find(item => String(item.id) === master.value);
      updateIncluded(root, variant || null);
    };
    root.addEventListener('change', event => { if (event.target === master) update(); }, { signal: controller.signal });
    update();
  }
  function recommendations(root) {
    const nodes = all(root, '[data-section-type="product-recommendations"][data-base-url]');
    nodes.forEach(node => {
      if (node.dataset.euRecommendations) return;
      node.dataset.euRecommendations = 'pending';
      const load = async () => {
        try {
          const url = new URL(node.dataset.baseUrl, location.origin);
          url.searchParams.set('product_id', node.dataset.productId); url.searchParams.set('section_id', node.dataset.sectionId); url.searchParams.set('limit', '4');
          const response = await fetch(url); if (!response.ok) return;
          const html = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('.product-recommendations__inner');
          if (node.isConnected && html) { node.replaceChildren(html); window.QuadroEUCollection?.init(node); window.QuadroEU?.init(node); }
        } catch (_) { /* Recommendations must never block the product form. */ }
      };
      if ('IntersectionObserver' in window) { const observer = new IntersectionObserver(entries => { if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); load(); } }, { rootMargin: '400px' }); observer.observe(node); }
      else load();
    });
  }
  function init(scope = document) {
    if (scope.matches?.('[data-eu-product]')) initProduct(scope);
    all(scope, '[data-eu-product]').forEach(initProduct);
    if (scope.matches?.('[data-panel-set-main-product]')) initMinimalPanelSet(scope);
    all(scope, '[data-panel-set-main-product]').forEach(initMinimalPanelSet);
    recommendations(scope);
  }
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => products.forEach((controller, root) => { if (event.target === root || event.target.contains(root)) { controller.abort(); products.delete(root); window.QuadroEUModels?.destroy(root); } }));
  window.QuadroEUProduct = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
})();
